import { getCookieByName } from './getCookieByName';

export function getCsrfToken() {
    return getCookieByName('_99csrf', typeof document !== 'undefined' ? document.cookie : '');
}
